import TeacherComponent from "../components/teachersComponent/teacherComponent";

const Teachers = () => {
  return <TeacherComponent />;
};

export default Teachers;
